import React from "react";

export const AddProviderIcon: React.FC = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15_10)">
        <mask
          id="mask0_15_10"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="-12"
          y="-11"
          width="44"
          height="44"
        >
          <path d="M32 -11H-12V33H32V-11Z" fill="white" />
        </mask>
        <g mask="url(#mask0_15_10)">
          <g filter="url(#filter0_d_15_10)">
            <path
              d="M10.2854 16.0371H8.13641L8.12515 18.3435C8.12381 18.6187 7.90035 18.8411 7.62516 18.8411H6.62272C6.34658 18.8411 6.12272 18.6172 6.12272 18.3411V16.0371H3.96219C3.68605 16.0371 3.46219 15.8132 3.46219 15.5371V14.5132C3.46219 14.2371 3.68605 14.0132 3.96219 14.0132H6.12899V11.8318C6.12899 11.5556 6.35284 11.3318 6.62899 11.3318H7.63385C7.90999 11.3318 8.13385 11.5556 8.13385 11.8318C8.13385 11.8326 8.13385 11.8335 8.13384 11.8343L8.12272 14.0132H10.2854C10.5615 14.0132 10.7854 14.2371 10.7854 14.5132V15.5371C10.7854 15.8132 10.5615 16.0371 10.2854 16.0371Z"
              fill="black"
            />
          </g>
          <path
            d="M10.2854 16.0371H8.13641L8.12515 18.3435C8.12381 18.6187 7.90035 18.8411 7.62516 18.8411H6.62272C6.34658 18.8411 6.12272 18.6172 6.12272 18.3411V16.0371H3.96219C3.68605 16.0371 3.46219 15.8132 3.46219 15.5371V14.5132C3.46219 14.2371 3.68605 14.0132 3.96219 14.0132H6.12899V11.8318C6.12899 11.5556 6.35284 11.3318 6.62899 11.3318H7.63385C7.90999 11.3318 8.13385 11.5556 8.13385 11.8318C8.13385 11.8326 8.13385 11.8335 8.13384 11.8343L8.12272 14.0132H10.2854C10.5615 14.0132 10.7854 14.2371 10.7854 14.5132V15.5371C10.7854 15.8132 10.5615 16.0371 10.2854 16.0371Z"
            fill="#208CFF"
          />
          <g filter="url(#filter1_d_15_10)">
            <path
              d="M9.68701 8.91281C10.3843 9.62081 11.2317 9.97481 12.2294 9.97481C13.227 9.97481 14.0771 9.62081 14.7798 8.91281C15.4824 8.20481 15.8337 7.35468 15.8337 6.3624C15.8337 5.37013 15.4824 4.52 14.7798 3.812C14.0771 3.104 13.227 2.75 12.2294 2.75C11.2317 2.75 10.3816 3.104 9.67896 3.812C8.97632 4.52 8.62501 5.37013 8.62501 6.3624C8.62501 7.35468 8.979 8.20481 9.68701 8.91281ZM10.5076 8.10826C10.0249 7.62554 9.78355 7.04359 9.78355 6.3624C9.78355 5.68122 10.0222 5.10195 10.4996 4.62459C10.977 4.14722 11.5535 3.90854 12.2294 3.90854C12.9052 3.90854 13.4818 4.14722 13.9591 4.62459C14.4365 5.10195 14.6752 5.68122 14.6752 6.3624C14.6752 7.04359 14.4365 7.62285 13.9591 8.10022C13.4818 8.57758 12.9052 8.81626 12.2294 8.81626C11.5535 8.81626 10.9796 8.58027 10.5076 8.10826ZM12.6736 17.6086C13.0143 17.9545 13.4283 18.1275 13.9158 18.1275C14.4033 18.1275 14.8186 17.9545 15.162 17.6086C15.5053 17.2626 15.6769 16.8472 15.6769 16.3624C15.6769 15.8776 15.5053 15.4622 15.162 15.1162C14.8186 14.7703 14.4033 14.5973 13.9158 14.5973C13.4283 14.5973 13.0129 14.7703 12.6696 15.1162C12.3263 15.4622 12.1547 15.8776 12.1547 16.3624C12.1547 16.8472 12.3276 17.2626 12.6736 17.6086ZM13.0445 17.2155C12.8087 16.9796 12.6907 16.6952 12.6907 16.3624C12.6907 16.0296 12.8074 15.7465 13.0406 15.5133C13.2739 15.28 13.5556 15.1634 13.8858 15.1634C14.216 15.1634 14.4977 15.28 14.731 15.5133C14.9642 15.7465 15.0809 16.0296 15.0809 16.3624C15.0809 16.6952 14.9642 16.9783 14.731 17.2115C14.4977 17.4448 14.216 17.5614 13.8858 17.5614C13.5556 17.5614 13.2752 17.4461 13.0445 17.2155ZM9.18573 10.6316C9.59873 10.8922 9.94982 11.1816 10.4433 11.4713C11.0118 11.246 11.6072 11.1334 12.2294 11.1334C13.6132 11.1334 14.7959 11.6241 15.7774 12.6057C16.759 13.5872 17.2497 14.7752 17.2497 16.1698C17.2497 16.1805 17.2497 16.1913 17.2497 16.202C17.2497 16.3629 17.306 16.4997 17.4187 16.6123C17.5313 16.7249 17.6681 16.7812 17.829 16.7812C17.9899 16.7812 18.1267 16.7249 18.2393 16.6123C18.3519 16.4997 18.4083 16.3629 18.4083 16.202C18.4083 16.202 18.4083 16.1966 18.4083 16.1859C18.4083 16.1752 18.4083 16.1698 18.4083 16.1698C18.4083 15.0434 18.132 14.0056 17.5796 13.0562C17.0271 12.1068 16.2762 11.3559 15.3269 10.8035C14.3775 10.251 13.345 9.97481 12.2294 9.97481C10.9957 9.97481 9.90674 10.2848 9.18573 10.6316Z"
              fill="black"
            />
          </g>
          <path
            d="M9.68701 8.91281C10.3843 9.62081 11.2317 9.97481 12.2294 9.97481C13.227 9.97481 14.0771 9.62081 14.7798 8.91281C15.4824 8.20481 15.8337 7.35468 15.8337 6.3624C15.8337 5.37013 15.4824 4.52 14.7798 3.812C14.0771 3.104 13.227 2.75 12.2294 2.75C11.2317 2.75 10.3816 3.104 9.67896 3.812C8.97632 4.52 8.62501 5.37013 8.62501 6.3624C8.62501 7.35468 8.979 8.20481 9.68701 8.91281ZM10.5076 8.10826C10.0249 7.62554 9.78355 7.04359 9.78355 6.3624C9.78355 5.68122 10.0222 5.10195 10.4996 4.62459C10.977 4.14722 11.5535 3.90854 12.2294 3.90854C12.9052 3.90854 13.4818 4.14722 13.9591 4.62459C14.4365 5.10195 14.6752 5.68122 14.6752 6.3624C14.6752 7.04359 14.4365 7.62285 13.9591 8.10022C13.4818 8.57758 12.9052 8.81626 12.2294 8.81626C11.5535 8.81626 10.9796 8.58027 10.5076 8.10826ZM12.6736 17.6086C13.0143 17.9545 13.4283 18.1275 13.9158 18.1275C14.4033 18.1275 14.8186 17.9545 15.162 17.6086C15.5053 17.2626 15.6769 16.8472 15.6769 16.3624C15.6769 15.8776 15.5053 15.4622 15.162 15.1162C14.8186 14.7703 14.4033 14.5973 13.9158 14.5973C13.4283 14.5973 13.0129 14.7703 12.6696 15.1162C12.3263 15.4622 12.1547 15.8776 12.1547 16.3624C12.1547 16.8472 12.3276 17.2626 12.6736 17.6086ZM13.0445 17.2155C12.8087 16.9796 12.6907 16.6952 12.6907 16.3624C12.6907 16.0296 12.8074 15.7465 13.0406 15.5133C13.2739 15.28 13.5556 15.1634 13.8858 15.1634C14.216 15.1634 14.4977 15.28 14.731 15.5133C14.9642 15.7465 15.0809 16.0296 15.0809 16.3624C15.0809 16.6952 14.9642 16.9783 14.731 17.2115C14.4977 17.4448 14.216 17.5614 13.8858 17.5614C13.5556 17.5614 13.2752 17.4461 13.0445 17.2155ZM9.18573 10.6316C9.59873 10.8922 9.94982 11.1816 10.4433 11.4713C11.0118 11.246 11.6072 11.1334 12.2294 11.1334C13.6132 11.1334 14.7959 11.6241 15.7774 12.6057C16.759 13.5872 17.2497 14.7752 17.2497 16.1698C17.2497 16.1805 17.2497 16.1913 17.2497 16.202C17.2497 16.3629 17.306 16.4997 17.4187 16.6123C17.5313 16.7249 17.6681 16.7812 17.829 16.7812C17.9899 16.7812 18.1267 16.7249 18.2393 16.6123C18.3519 16.4997 18.4083 16.3629 18.4083 16.202C18.4083 16.202 18.4083 16.1966 18.4083 16.1859C18.4083 16.1752 18.4083 16.1698 18.4083 16.1698C18.4083 15.0434 18.132 14.0056 17.5796 13.0562C17.0271 12.1068 16.2762 11.3559 15.3269 10.8035C14.3775 10.251 13.345 9.97481 12.2294 9.97481C10.9957 9.97481 9.90674 10.2848 9.18573 10.6316Z"
            fill="#208CFF"
            stroke="#208CFF"
            strokeWidth="0.7"
          />
          <g filter="url(#filter2_d_15_10)">
            <path
              d="M14.988 10.2375L14.0712 9.87864C14.5621 9.59888 15.1133 9.07983 15.4699 8.62945C16.3577 8.58312 17.1548 8.74862 17.7876 9.32316C20 11.3318 18.1302 15.2504 16 16.7812L15.5348 15.2504C16.907 14.3636 18.1302 11.8015 16.7946 10.5777C16.2548 10.0831 15.3584 10.125 14.988 10.2375Z"
              fill="black"
            />
          </g>
          <path
            d="M14.988 10.2375L14.0712 9.87864C14.5621 9.59888 15.1133 9.07983 15.4699 8.62945C16.3577 8.58312 17.1548 8.74862 17.7876 9.32316C20 11.3318 18.1302 15.2504 16 16.7812L15.5348 15.2504C16.907 14.3636 18.1302 11.8015 16.7946 10.5777C16.2548 10.0831 15.3584 10.125 14.988 10.2375Z"
            fill="#208CFF"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_15_10"
          x="0.462189"
          y="9.33177"
          width="13.3232"
          height="13.5093"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0235294 0 0 0 0 0.615686 0 0 0 0 0.870588 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_10"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_10"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_15_10"
          x="5.625"
          y="0.75"
          width="15.7833"
          height="21.3775"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0235294 0 0 0 0 0.615686 0 0 0 0 0.870588 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_10"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_10"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_15_10"
          x="11.0712"
          y="6.62209"
          width="10.7115"
          height="14.1592"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0235294 0 0 0 0 0.615686 0 0 0 0 0.870588 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_10"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_10"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_15_10">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
